import { render, staticRenderFns } from "./mobile-gallery.vue?vue&type=template&id=98d078a2&"
import script from "./mobile-gallery.vue?vue&type=script&lang=ts&"
export * from "./mobile-gallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d078a2')) {
      api.createRecord('98d078a2', component.options)
    } else {
      api.reload('98d078a2', component.options)
    }
    module.hot.accept("./mobile-gallery.vue?vue&type=template&id=98d078a2&", function () {
      api.rerender('98d078a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mobile-gallery/mobile-gallery.vue"
export default component.exports